module.exports = __webpack_public_path__ + "static/media/gps-place.0175390e.svg";